import { render, staticRenderFns } from "./jointPreferencesDetail.vue?vue&type=template&id=343d8fba&scoped=true&"
import script from "./jointPreferencesDetail.vue?vue&type=script&lang=js&"
export * from "./jointPreferencesDetail.vue?vue&type=script&lang=js&"
import style0 from "./jointPreferencesDetail.vue?vue&type=style&index=0&id=343d8fba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343d8fba",
  null
  
)

export default component.exports